// Presentation only. MENU owns order, labels, routes and authorization.
(function () {
  'use strict';
  var sections = {
    workspace: ['Workspace', 'Rad'],
    business: ['Business', 'Poslovanje'],
    resources: ['Resources', 'Resursi'],
    manage: ['Manage', 'Upravljanje']
  };
  function decorate() {
    var tree = document.getElementById('t_TreeNav');
    if (!tree) { return; }
    var hr = /^hr/i.test(document.documentElement.lang);
    var previous = '';
    tree.querySelectorAll(':scope > ul > .a-TreeView-node').forEach(function (node) {
      var icon = node.querySelector(':scope > .a-TreeView-content > [class*="lp-nav-"]');
      var match = icon && icon.className.match(/\blp-nav-(workspace|business|resources|manage)\b/);
      var group = match ? match[1] : '';
      var label = node.querySelector(':scope > .a-TreeView-content > .a-TreeView-label');
      node.classList.toggle('lp-nav-section-start', !!group && group !== previous);
      if (group) {
        node.setAttribute('data-lp-section', sections[group][hr ? 1 : 0]);
        if (label) { label.setAttribute('aria-description', sections[group][hr ? 1 : 0]); }
      }
      if (label) { label.parentElement.title = label.textContent.trim(); }
      previous = group;
    });
    tree.querySelectorAll('.a-TreeView-label').forEach(function (label) {
      label.title = label.textContent.trim();
    });
    tree.classList.add('lp-side-navigation');
  }
  function ready() {
    var nav = document.getElementById('t_Body_nav');
    if (!nav || nav.hasAttribute('data-lp-navigation-ready')) { return; }
    nav.setAttribute('data-lp-navigation-ready', 'true');
    // Native tree focus also follows pointer selection. Reserve its ring for keys.
    document.addEventListener('pointerdown', function () {
      var tree = document.getElementById('t_TreeNav');
      if (tree) { tree.setAttribute('data-lp-nav-input', 'pointer'); }
    }, true);
    document.addEventListener('keydown', function (event) {
      if (event.altKey || event.ctrlKey || event.metaKey || /^(Shift|Control|Alt|Meta)$/.test(event.key)) { return; }
      var tree = document.getElementById('t_TreeNav');
      if (tree) { tree.setAttribute('data-lp-nav-input', 'keyboard'); }
    }, true);
    var queued = false;
    new MutationObserver(function () {
      if (queued) { return; }
      queued = true;
      requestAnimationFrame(function () { queued = false; decorate(); });
    }).observe(nav, {childList:true, subtree:true});
    decorate();
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', ready); }
  else { ready(); }
})();
